export const currentTime = (time: number) => {
  const now = new Date();
  const unixTimestampCurrent = Math.floor(now.getTime() / 1000);
  return (time - unixTimestampCurrent);
}

export const getDateYearsAgo = (date: Date, years: number): Date => {
  const year = date.getFullYear() - years;
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(year, month, day);
}

export const getDateYearsTo = (date: Date, years: number): Date => {
  const year = date.getFullYear() + years;
  const month = date.getMonth();
  const day = date.getDate();
  return new Date(year, month, day);
}
